import type { PublicHuntType, PublicRelease } from "../api/types";

export type ConfirmedRarity = "STH" | "TH" | "Exclusive";

export function confirmedRarities(release: {
  huntType: PublicHuntType;
  isExclusive: boolean;
}): ConfirmedRarity[] {
  const badges: ConfirmedRarity[] = [];
  if (release.huntType === "STH") {
    badges.push("STH");
  } else if (release.huntType === "TH") {
    badges.push("TH");
  }
  if (release.isExclusive) {
    badges.push("Exclusive");
  }
  return badges;
}

export function isConfirmedRare(release: {
  huntType: PublicHuntType;
  isExclusive: boolean;
}): boolean {
  return confirmedRarities(release).length > 0;
}

/**
 * Canonical rarity rank shared with Catalog search (`rare_first`).
 * Lower sorts first: STH, TH, Exclusive-only, then ordinary.
 */
export function rarityRankOf(
  huntType: PublicHuntType,
  isExclusive: boolean,
): number {
  if (huntType === "STH") {
    return 0;
  }
  if (huntType === "TH") {
    return 1;
  }
  if (isExclusive) {
    return 2;
  }
  return 3;
}

export function rarityAccent(release: PublicRelease): ConfirmedRarity | null {
  const badges = confirmedRarities(release);
  return badges[0] ?? null;
}
